import React, { HTMLAttributes, useState } from "react";
import { OdsIntegerFilterDialog } from "../../../dialogs/filter-dialogs/integer-filter/integer-filter.dialog";
import { IntegerFilter } from "../../../models/integer-filter";
import { ListResult } from "../../../models/list-result";
import { ViewHelper } from "../../../services/view-helpers";

export interface OdsIntegerColumnHeaderProps {
    header: React.ReactNode;
    name: string;
    filter?: IntegerFilter;
    sort?: string;
    sortDirection?: string;
    onSortChanged?: (sort: string, sortDirection: string) => void;
    onFilterChanged?: (newFilter?: IntegerFilter) => void;
    onSearch?: (columnName: string, top: number, skip: number, filter: string) => Promise<ListResult<string>>;
}

export const OdsIntegerColumnHeader: React.FC<OdsIntegerColumnHeaderProps & HTMLAttributes<HTMLSpanElement>> = ({
    header,
    name,
    filter,
    sort,
    sortDirection,
    onSortChanged,
    onFilterChanged,
    onSearch,
    ...props
}) => {
    const [showFilter, setShowFilter] = useState<boolean>(false);

    const onFilterList = (columnName: string) => {
        setShowFilter(true);
    }

    const onDoSearch = async (top: number, skip: number, filter: string): Promise<ListResult<string>> => {
        if (onSearch) {
            return await onSearch(name, top, skip, filter);
        }
        else {
            return { totalCount: 0, items: [] };
        }
    }

    const onFilterComplete = (dialogResult: boolean, newFilter?: IntegerFilter) => {
        setShowFilter(false);
        if (dialogResult && onFilterChanged) {
            onFilterChanged(newFilter);
        }
    }

    const onDrawSort = (columnName: string) => {
        return ViewHelper.drawSort(columnName, sort, sortDirection, onSortChanged);
    };

    const onDrawFilter = (columnName: string, filtered: boolean) => {
        return ViewHelper.drawFilter(columnName, filtered, onFilterList, onFilterChanged);
    }

    return (
        <th>
            <OdsIntegerFilterDialog
                header={header}
                show={showFilter}
                filter={filter}
                onSearch={onDoSearch}
                onComplete={onFilterComplete}
            />
            <span className="ods-column-header center-column" {...props}>{header}{onDrawSort(name)}{onDrawFilter(name, !!filter)}</span>
        </th>
    )
};
